// resultUnits: miles - false, kilometers - true
export const convertUnitsOfMeasurement = (
  value: number,
  resultUnits: boolean
) => (resultUnits ? Math.round(value * 1.609) : Math.round(value / 1.609));
